import React from 'react';
import Modal from '../../Modal';
import { inject, observer } from 'mobx-react';
import { dataDelivery as api } from '../../../actions/api'
import { observable, toJS } from 'mobx';
import DataTable from '../../DataTable';
import { getDisplayDate } from '../../../libs/date';

@inject('userStore', 'dataSourceStore')
@observer
class RawDataExportAudit extends React.Component {
  static contextTypes = {
    notify: React.PropTypes.object.isRequired,
  };


  @observable items = [];
  @observable isLoading = false;
  @observable originView = false;
  @observable allOrigins = [];

  columns = [
    { key: 'user.name', label: 'Modified By' },
    { key: 'timestamp', label: 'Timestamp' },
    { key: 'name', label: 'Name' },
    { key: 'url', label: 'URL' },
    { key: 'raw_data_id', label: 'Raw Data From' },
    { key: 'raw_data_end', label: 'Raw Data To' },
    { key: 'status', label: 'Enabled' },
    { key: 'origins', label: '' },
  ];
  originCols = [
    { key: 'id', label: 'ID' },
    { key: 'source', label: 'Source' },
    { key: 'code', label: 'Code' },
    { key: 'station', label: 'Station' },
  ]
  slug = `/export/raw-data-export`;

  componentWillMount() {
    const { params: { id }, userStore, dataSourceStore } = this.props;
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    if (!dataSourceStore.items.length && !dataSourceStore.isLoading) dataSourceStore.fetchItems();
    api.rawExport.audit.fetchAll(id).then(res => {
      this.items = res;
      this.isLoading = false;
    }).catch(err => {
      console.log(err);
      this.isLoading = false;
      this.context.notify.error({ message: err.toString() });
    });
    this.populateOptions();
  }

  populateOptions = () => {
    const { dataSourceStore } = this.props;
    if (dataSourceStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      let allOrigins = [];
      dataSourceStore.items.forEach(ds => {
        ds.origins.forEach(origin => {
          let station = !origin.stations || !origin.stations.length ? '' : origin.stations[0].name;
          allOrigins.push({ id: origin.id, source: ds.name, code: origin.code, station });
        })
      });
      this.allOrigins = allOrigins;
    }
  };

  _renderOrigins = (id) => {
    const items = this.items.find(item => item.id === id).origins.split(',').map(id => {
      const origin = this.allOrigins.find(i => +i.id === +id);
      if (!origin) return { id };
      return {
        id,
        source: origin.source,
        code: origin.code,
        station: origin.station,
      }
    });

    return (
      <Modal title='Origins' slug={this.slug} closeModal={() => this.originView = null}>
        <div>
          <DataTable data={items} columns={this.originCols} />
          <br />
        </div>
      </Modal>
    )
  }

  render() {
    const { params, onClose, userStore } = this.props;
    const items = this.items.map(item => {
      return Object.assign({}, toJS(item), {
        timestamp: getDisplayDate(item.timestamp),
        user: userStore.findById(item.user_id),
        status: <i className='fa fa-circle' style={{ color: !!+item.status ? 'green' : 'red' }} data-toggle="tooltip" title={!!+item.status ? 'Enabled' : 'Disabled'} />,
        origins: <a style={{ cursor: 'pointer' }} onClick={(e) => {
          e.stopPropagation();
          this.originView = item.id
        }}>Origins</a>,
      });
    })
    return (
      <Modal title='Audit History' slug={this.slug} closeModal={onClose} isLoading={userStore.isLoading || this.isLoading}>
        <div>
          <DataTable data={items} columns={this.columns} />
          <br />
          {!!this.originView && this._renderOrigins(this.originView)}
        </div>
      </Modal>
    );
  }
}

export default RawDataExportAudit;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/RawDataExport/RawDataExportAudit.js